<template>
    <v-container>
        <v-row>
            <v-col>
                <h1>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon
                                   @click="$router.push({name: 'home'})"
                                   v-on="on"
                            >
                                <v-icon x-large>mdi-chevron-left</v-icon>
                            </v-btn>
                        </template>
                        <span>Go Back</span>
                    </v-tooltip>
                    Campaign - {{ campaign.title }}
                </h1>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" sm="6">
                <v-card>
                    <v-card-title>Campaign Information</v-card-title>

                    <v-card-text>
                        <v-row>
                            <v-col cols="12" lg="6">
                                <div class="subtitle-2">General Information</div>
                                <div>
                                    Prosperity: {{ campaign.prosperity }} ({{ campaign.prosperity_at_next_level || "-"
                                    }})

                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon
                                                   color="error"
                                                   @click="lowerCampaignProsperity(campaign)"
                                                   v-on="on"
                                            >
                                                <v-icon>mdi-minus-circle</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Decrease Prosperity</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon
                                                   color="primary"
                                                   @click="raiseCampaignProsperity(campaign)"
                                                   v-on="on"
                                            >
                                                <v-icon>mdi-plus-circle</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Increase Prosperity</span>
                                    </v-tooltip>
                                </div>
                                <div>Donations to the Sanctuary of the Great Oak: {{ campaign.donations }} ({{
                                    campaign.donations_at_next_prosperity || "-" }})
                                </div>
                            </v-col>

                            <v-col cols="12" lg="6">
                                <div class="subtitle-2">New Character Information</div>
                                <div>Starting Level: {{ campaign.characterStartingLevel }}</div>
                                <div>Starting Gold: {{ campaign.characterStartingGold }}</div>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <v-textarea v-model="notes"
                                            outlined
                                            auto-grow
                                            @input="updateNotesDelay($route.params.campaignId)"
                                            label="Notes"/>

                                <v-chip color="warning" v-if="notesSaving">
                                    <v-progress-circular indeterminate size="18" width="2" class="mr-4"/>
                                    Saving...
                                </v-chip>
                                <v-chip color="success" v-else>
                                    <v-icon class="mr-2">mdi-check</v-icon>
                                    Saved
                                </v-chip>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <div class="mt-2 subtitle-2">Members:</div>
                                <div v-for="user of campaign.users" :key="user.name">{{ user.name }}</div>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-divider/>

                    <v-card-actions>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon
                                       color="primary"
                                       @click="$router.push({name: 'attach-user-to-campaign', params: {campaignId: campaign.id}})"
                                       v-on="on"
                                >
                                    <v-icon>mdi-account-plus</v-icon>
                                </v-btn>
                            </template>
                            <span>Add User</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon
                                       color="primary"
                                       @click="$router.push({name: 'detach-user-from-campaign', params: {campaignId: campaign.id}})"
                                       v-on="on"
                                >
                                    <v-icon>mdi-account-minus</v-icon>
                                </v-btn>
                            </template>
                            <span>Remove User</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon
                                       color="error"
                                       @click="destroyCampaign"
                                       v-on="on"
                                >
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </template>
                            <span>Delete Campaign</span>
                        </v-tooltip>
                    </v-card-actions>
                </v-card>

              <v-card class="mt-6">
                <v-card-title>Achievements</v-card-title>

                <v-card-text>
                  <div v-for="(achievement, achievementIndex) in campaign.achievements" :key="achievementIndex">
                <span>
                  {{ achievement.title }}
                  <span v-if="achievement.levels > 1"> - Level {{ achievement.level }}</span>
                </span>
                  </div>
                </v-card-text>
              </v-card>

                <v-card class="mt-6">
                    <v-card-title>Parties</v-card-title>

                    <v-card-text>
                        <v-row>
                            <v-col cols="12" v-for="(party, partyIndex) in campaign.parties" :key="partyIndex">
                                <div class="title">
                                    <span>
                                        {{ party.name }}
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon
                                                       color="primary"
                                                       @click="$router.push({name: 'party', params: {partyId: party.id}})"
                                                       v-on="on">
                                                    <v-icon>mdi-eye</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>View Party</span>
                                        </v-tooltip>
                                    </span>
                                </div>
                                <div>Characters: {{ party.character_count }}</div>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-divider/>

                    <v-card-actions>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon
                                       color="primary"
                                       @click="$router.push({name: 'create-party', params: {campaignId: $route.params.campaignId}})"
                                       v-on="on"
                                >
                                    <v-icon>mdi-account-multiple-plus</v-icon>
                                </v-btn>
                            </template>
                            <span>Create Party</span>
                        </v-tooltip>
                    </v-card-actions>
                </v-card>

                <v-card class="mt-6">
                    <v-card-title>Available Classes</v-card-title>

                    <v-card-text>
                        <div v-for="(characterClass, characterClassIndex) in campaign.character_classes"
                             :key="characterClassIndex">
                            <v-avatar size="32" class="mb-2 mr-2">
                                <v-img :src="getClassAvatar(characterClass)"/>
                            </v-avatar>
                            {{ characterClass.name }}
                        </div>
                    </v-card-text>

                    <v-divider/>

                    <v-card-actions>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon
                                       color="primary"
                                       @click="$router.push({name: 'attach-character-class', params: {campaignId: $route.params.campaignId}})"
                                       v-on="on"
                                >
                                    <v-icon>mdi-lock-open</v-icon>
                                </v-btn>
                            </template>
                            <span>Unlock Class</span>
                        </v-tooltip>
                    </v-card-actions>
                </v-card>
            </v-col>

            <v-col cols="12" sm="6">
                <v-card>
                    <v-card-title>Scenarios</v-card-title>

                    <v-card-text>
                        <div v-for="(scenario, scenarioIndex) in scenarios" :key="scenarioIndex">

                            <span v-if="scenario.unlocked"
                                  style="cursor: pointer;"
                                  @click="detachScenario(scenarioIndex)"
                                  class="grey--text text--darken-4">{{ scenario.select_text }}</span>

                            <span v-else
                                  style="cursor: pointer;"
                                  @click="attachScenario(scenarioIndex)"
                                  class="grey--text text--lighten-1">{{ scenario.select_text }}</span>

                        </div>
                    </v-card-text>

                    <v-divider/>

                    <v-card-actions>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon
                                       color="primary"
                                       @click="$router.push({name: 'create-scenario', params: {campaignId: $route.params.campaignId}})"
                                       v-on="on"
                                >
                                    <v-icon>mdi-plus-box</v-icon>
                                </v-btn>
                            </template>
                            <span>Create And Unlock Scenario</span>
                        </v-tooltip>
                    </v-card-actions>
                </v-card>

                <v-card class="mt-6">
                    <v-card-title>Available Items</v-card-title>

                    <v-card-text>
                        <div v-for="(item, itemIndex) in campaign.items" :key="itemIndex">
                            {{ item.amount }} pcs of #{{ item.number }} - {{ item.slot }} - {{ item.title }}
                        </div>
                    </v-card-text>

                    <v-divider/>

                    <v-card-actions>
                        <create-item-dialog :campaign="campaign" @itemStored="viewCampaign"/>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon
                                       color="primary"
                                       @click="$router.push({name: 'unlock-design', params: {campaignId: $route.params.campaignId}})"
                                       v-on="on"
                                >
                                    <v-icon>mdi-lock-open</v-icon>
                                </v-btn>
                            </template>
                            <span>Unlock Item Design</span>
                        </v-tooltip>

                        <v-tooltip bottom v-if="campaign.items_unlockable">
                            <template v-slot:activator="{ on }">
                                <v-btn class="ml-2 my-2"
                                       color="warning"
                                       @click="unlockItemsByProsperity"
                                       v-on="on"
                                >
                                    <v-icon>mdi-folder-lock-open</v-icon>
                                </v-btn>
                            </template>
                            <span>Unlock Items Due To Prosperity</span>
                        </v-tooltip>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
  import CampaignService from "../services/CampaignService";
  import ScenarioService from "../services/ScenarioService";
  import CreateItemDialog from "./CreateItemDialog";

  export default {
    components: {
      CreateItemDialog
    },

    data: () => ({
      campaign: null,
      notes: null,
      notesTimeout: null,
      notesSaving: false,
      scenarios: []
    }),

    created() {
      this.viewCampaign();
      this.indexScenarios();
    },

    methods: {
      viewCampaign() {
        CampaignService.view(this.$route.params.campaignId)
          .then(response => {
            this.campaign = response.data.data;
            this.notes = this.campaign.notes;
          })
          .catch(err => {
            console.log(err);
          });
      },

      indexScenarios() {
        ScenarioService.indexByCampaign(this.$route.params.campaignId)
          .then(response => {
            this.scenarios = response.data.data;
          })
          .catch(err => {
            console.log(err);
          });
      },

      raiseCampaignProsperity(campaign) {
        CampaignService.raiseProsperity(campaign.id)
          .then(() => {
            this.viewCampaign();
          })
          .catch(err => {
            console.log(err);
          });
      },

      lowerCampaignProsperity(campaign) {
        CampaignService.lowerProsperity(campaign.id)
          .then(() => {
            this.viewCampaign();
          })
          .catch(err => {
            console.log(err);
          });
      },

      unlockItemsByProsperity() {
        CampaignService.unlockItemsByProsperity(this.$route.params.campaignId)
          .then(() => {
            this.viewCampaign();
          })
          .catch(err => {
            console.log(err);
          });
      },

      updateNotesDelay(campaignId) {
        this.notesSaving = true;

        if (this.notesTimeout) {
          clearTimeout(this.notesTimeout);
          this.notesTimeout = null;
        }

        this.notesTimeout = setTimeout(() => {
          this.updateNotes(campaignId);
        }, 3000);
      },

      updateNotes(campaignId) {
        CampaignService.updateNotes(campaignId, {
          notes: this.notes
        })
          .then(() => {
            this.notesSaving = false;
          })
          .catch(err => {
            console.log(err);
            this.notesSaving = false;
          });
      },

      getClassAvatar(characterClass) {
        try {
          return require(`@/assets/${characterClass.slug}.png`);
        } catch (e) {
          return "";
        }
      },

      attachScenario(scenarioIndex) {
        this.scenarios[scenarioIndex].unlocked = true;

        CampaignService.attachScenario(this.campaign.id, this.scenarios[scenarioIndex].id)
          .then(() => {
            this.indexScenarios();
          })
          .catch(err => {
            console.log(err);
            this.indexScenarios();
          });
      },

      detachScenario(scenarioIndex) {
        this.scenarios[scenarioIndex].unlocked = false;

        CampaignService.detachScenario(this.campaign.id, this.scenarios[scenarioIndex].id)
          .then(() => {
            this.indexScenarios();
          })
          .catch(err => {
            console.log(err);
            this.indexScenarios();
          });
      },

      destroyCampaign() {
        if (confirm(`Are you sure you want to delete the campaign named ${this.campaign.title}?`)) {
          CampaignService.destroy(this.campaign.id)
            .then(() => {
              this.$router.push({name: 'home'});
            })
            .catch(err => {
              console.log(err);
            });
        }
      }
    }
  };
</script>